module.exports = __webpack_public_path__ + "img/automotive-dark.0aa8f1cb.webp";